import classNames from "classnames";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import gfm from "remark-gfm";

import useWindow from "../hooks/useWindow";
import styles from "../styles/components/typeface.module.scss";

export function Divider({ className }: { className?: string }) {
  return <div className={classNames(styles.divider, className)} />;
}

interface PreHeadingProps {
  color?: string;
  children: React.ReactNode;
}

export function PreHeading({ color, children }: PreHeadingProps) {
  return (
    <p className={classNames(styles.preHeading, color && styles[color])}>
      {children}
    </p>
  );
}

interface QuoteProps {
  author: string;
  children: React.ReactNode;
}

export const Quote = ({ author, children }: QuoteProps) => {
  return (
    <div className={styles.quoteContainer}>
      <div className={styles.quote}>{children}</div>
      <h4>{author}</h4>
    </div>
  );
};

interface QuoteBoxProps {
  className?: string;
  children: React.ReactNode;
}

export function QuoteBox({ className, children }: QuoteBoxProps) {
  return (
    <div className={classNames(styles.quoteBox, className)}>{children}</div>
  );
}

interface StyledMarkdownProps {
  color?: string;
  className?: string;
  components?: any;
  children?: any;
}

export const StyledMarkdown = ({
  color,
  className,
  components,
  children,
}: StyledMarkdownProps) => {
  const _window = useWindow();

  return (
    <span className={classNames(styles.markdown, className)}>
      <ReactMarkdown
        remarkPlugins={[gfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          em: ({ node, ...props }) => (
            <em className={color ? styles[color] : undefined} {...props} />
          ),
          h1: ({ node, ...props }) => (
            <h1 {...props} style={{ textAlign: "center" }} />
          ),
          hr: () => <Divider />,
          ...components,
          a: ({ node, ...props }) => {
            const newTab =
              props.href &&
              props.href.indexOf(_window.location.origin) === -1 &&
              !/^[/#]/.test(props.href);

            return (
              <a
                {...props}
                target={newTab ? "_blank" : undefined}
                rel={newTab ? "noreferrer" : undefined}
              />
            );
          },
        }}
      >
          {typeof children === "string" ? children : ""}
        </ReactMarkdown>
    </span>
  );
};
